import { apiClient } from '@shared/utils/api-client';
import type { Section, CreateSectionDto, UpdateSectionDto } from '../types';

export const sectionsApi = {
  create: async (data: CreateSectionDto, file?: File): Promise<Section> => {
    const formData = new FormData();
    formData.append('name', data.name);
    if (file) {
      formData.append('image', file);
    }
    return apiClient.post<Section>('/sections', formData);
  },
  
  getAll: async (): Promise<Section[]> => {
    return apiClient.get<Section[]>('/sections');
  },
  
  getById: async (id: number): Promise<Section> => {
    return apiClient.get<Section>(`/sections/${id}`);
  },

  update: async (id: number, data: UpdateSectionDto, file?: File): Promise<Section> => {
    const formData = new FormData();
    if (data.name !== undefined) {
      formData.append('name', data.name);
    }
    if (data.shouldDeleteImage !== undefined) {
      formData.append('shouldDeleteImage', String(data.shouldDeleteImage));
    }
    if (file) {
      formData.append('image', file);
    }
    return apiClient.put<Section>(`/sections/${id}`, formData);
  },

  setHidden: async (id: number, isHidden: boolean): Promise<Section> => {
    return apiClient.patch<Section>(`/sections/${id}/hidden`, { isHidden });
  },

  delete: async (id: number): Promise<void> => {
    return apiClient.delete(`/sections/${id}`);
  },
};

